import { useSelector } from 'react-redux';
import { ReducerKeys } from '..';
import _ from 'lodash';
import { AuthRoles } from '../../../config';
import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';

export const useSelectUserRole = () => {
  return useSelector((state: any) =>
    _.get(state[ReducerKeys.AUTH_REDUCER], 'role', AuthRoles.Guest)
  );
};

export const useSelectUserData = () => {
  const { username, email } = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.AUTH_REDUCER].data
  );
  return { username, email };
};

export const useSelectAuthStatus = () => {
  const status = useSelector(
    (state: any) => state[ReducerKeys.AUTH_REDUCER].status
  );
  return status;
};

export const useSelectedVersion = () => {
  const version = useSelector(
    (state: any) => state[ReducerKeys.AUTH_REDUCER].version
  );
  return version;
};

export const useIsLogin = (): boolean => {
  const isLogin = useSelector(
    (state: any) => state[ReducerKeys.AUTH_REDUCER].login
  );
  return isLogin;
};
